/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {

	const header = document.querySelector('#masthead.site-header');
	let scrolling = false;
	let prevScrollPos = window.pageYOffset;
	let currentScrollPos = window.pageYOffset;
	let activeHeaderHideLogic = true;

	document.addEventListener(
		'scroll',
		(event) => {
			currentScrollPos = window.pageYOffset;
			scrolling = true;
		},
		{passive: true}
	);

	setInterval(() => {
		if (activeHeaderHideLogic && scrolling) {
			if (currentScrollPos < 250 || prevScrollPos > currentScrollPos) {
				header.classList.remove('hide');
			} else {
				header.classList.add('hide');
			}
			prevScrollPos = currentScrollPos;
		}
		scrolling = false;
	}, 300);

	const siteNavigation = document.getElementById('site-navigation');

	// Return early if the navigation don't exist.
	if (!siteNavigation) {
		return;
	}

	const hamburgerButton : HTMLButtonElement = document.querySelector('.menu-toggle.hamburger');

	// Return early if the button don't exist.
	if ('undefined' === typeof hamburgerButton) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName('ul')[0];

	// Hide menu toggle button if menu is empty and return early.
	if ('undefined' === typeof menu) {
		hamburgerButton.style.display = 'none';
		return;
	}

	if (!menu.classList.contains('nav-menu')) {
		menu.classList.add('nav-menu');
	}

	var scrollPosition = 0;

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	hamburgerButton.addEventListener('click', function () {
		siteNavigation.classList.toggle('toggled');
		hamburgerButton.classList.toggle('toggled');
		if (document.documentElement.classList.contains('no-scroll')) {
			enableScrolling();
			setTimeout(() => {
				activeHeaderHideLogic = true;
			}, 500);
		} else {
			disableScrolling();
			scrolling = false;
			activeHeaderHideLogic = false;
		}

		if (hamburgerButton.getAttribute('aria-expanded') === 'true') {
			hamburgerButton.setAttribute('aria-expanded', 'false');
		} else {
			hamburgerButton.setAttribute('aria-expanded', 'true');
		}
	}, {passive: true});

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener('click', function (event) {
		const isClickInside = siteNavigation.contains((<HTMLButtonElement>event.target)) || hamburgerButton.contains((<HTMLButtonElement>event.target));

		if (!isClickInside) {
			siteNavigation.classList.remove('toggled');
			hamburgerButton.classList.remove('toggled');
			hamburgerButton.setAttribute('aria-expanded', 'false');
			enableScrolling();
		}
	}, {passive: true});

	// Remove the .toggled class and set aria-expanded to false when the user press ESC.
	document.addEventListener('keydown', function (event) {

		if (siteNavigation.classList.contains('toggled') && event.keyCode === 27) {
			siteNavigation.classList.remove('toggled');
			hamburgerButton.classList.remove('toggled');
			hamburgerButton.setAttribute('aria-expanded', 'false');
			enableScrolling();
			setTimeout(() => {
				activeHeaderHideLogic = true;
			}, 500);
		}
	}, {passive: true});

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName('a');

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

	// Toggle focus each time a menu link is focused or blurred.
	for (let i = 0; i < links.length; i++) {
		const link = links[i];
		link.addEventListener('focus', toggleFocus, {capture: true, passive: false});
		link.addEventListener('blur', toggleFocus, {capture: true, passive: false});
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if (event.type === 'focus' || event.type === 'blur') {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains('nav-menu')) {
				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					self.classList.toggle('focus');
				}
				self = self.parentNode;
			}
		}

		if (event.type === 'touchstart') {
			const menuItem = this.parentNode;
			event.preventDefault();
			for (let i = 0; i < menuItem.parentNode.children.length; i++) {
				const link = menuItem.parentNode.children[i];
				if (menuItem !== link) {
					link.classList.remove('focus');
				}
			}
			menuItem.classList.toggle('focus');
		}
	}

	/**
	 * Disables scrolling
	 */
	function disableScrolling() {
		scrollPosition = document.documentElement.scrollTop;
		document.documentElement.style.top = '-' + (scrollPosition) + 'px';
		document.documentElement.classList.add('no-scroll', 'disable-smooth-scroll');
	}

	/**
	 * Enables scrolling
	 */
	function enableScrolling() {
		if (document.documentElement.classList.contains('no-scroll')) {
			document.documentElement.classList.remove('no-scroll');
			window.scrollTo({
				top: scrollPosition,
        left: 0,
        behavior: 'auto'
			});
			document.documentElement.style.top = '';
			document.documentElement.classList.remove('disable-smooth-scroll');
			scrolling = false;
		}
	}
}());

